<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-toolbar cad color="primary" dark dense flat>
            <v-toolbar-title class="subheading">{{
              $route.meta.title
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text>
            <v-form>
              <v-layout row wrap>
                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('firstName')"
                    data-vv-name="firstName"
                    label="Nombre"
                    required
                    v-model="form.firstName"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('lastName')"
                    data-vv-name="lastName"
                    label="Apellido"
                    required
                    v-model="form.lastName"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('email')"
                    data-vv-name="email"
                    label="Email"
                    required
                    type="email"
                    v-model="form.email"
                    v-validate="'required|email'"
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :append-icon="
                      showPassword ? 'visibility' : 'visibility_off'
                    "
                    :error-messages="errors.collect('password')"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    data-vv-name="password"
                    label="Contraseña"
                    v-model="form.password"
                    v-validate="form.id ? '' : 'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-select
                    :error-messages="errors.collect('role')"
                    :items="roles"
                    data-vv-name="role"
                    label="Tipo de usuario"
                    no-data-text="Datos no disponibles"
                    required
                    v-model="form.roleId"
                    v-validate="'required'"
                  ></v-select>
                </v-flex>
                <v-flex md12 xs12>
                  <v-switch
                    :label="
                      `¿Usuario habilitado? - ${form.enabled ? 'Si' : 'No'}`
                    "
                    v-model="form.enabled"
                  ></v-switch>
                </v-flex>
                <v-flex md12 xs12>
                  <v-btn @click="submit" color="success">Enviar</v-btn>
                  <v-btn
                    @click="$router.push('/usuarios/listado')"
                    color="error"
                    >Cancelar</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-dialog max-width="500" v-if="dialog.message" v-model="dialog.show">
        <message
          :key="dialog.key"
          :options="dialog"
          v-on:close="dialog.show = false"
        ></message>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import message from './../dialog/Message'
export default {
  components: {
    message,
  },
  props: {
    form: {
      type: Object,
      default() {
        return {
          firstName: '',
          lastName: '',
          email: '',
          password: '',
          roleId: '',
          enabled: 1,
        }
      },
    },
  },
  data() {
    return {
      showPassword: false,
      roles: [],
      dialog: {
        show: false,
        key: 0,
      },
    }
  },
  created() {
    this.$store.dispatch('users/getRoles').then(userRoles => {
      for (let index = 0; index < userRoles.length; index += 1) {
        this.roles.push({
          text: userRoles[index].name,
          value: userRoles[index].id,
        })
      }

      if ('id' in this.$route.params) {
        this.$store
          .dispatch('users/getById', {
            id: this.$route.params.id,
          })
          .then(response => {
            if (response) {
              this.form = Object.assign(this.form, {
                id: response.id,
                firstName: response.firstName,
                lastName: response.lastName,
                email: response.email,
                roleId: response.roleId,
                enabled: response.enabled,
              })
            } else {
              this.$router.push('/usuarios/listado')
            }
          })
      }
    })
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.dispatch('users/save', this.form).then(response => {
            if (response.status === 200) {
              if (this.form.id) {
                this.dialog = {
                  message: 'Los datos fueron actualizados exitosamente',
                  color: 'primary',
                  show: true,
                  key: this.dialog.key + 1,
                }
              } else {
                this.$router.push('/usuarios/listado?success=true')
              }
            } else {
              this.dialog = {
                message: response.data.error,
                color: 'error',
                show: true,
                key: this.dialog.key + 1,
              }
            }
          })
        }
      })
    },
  },
}
</script>
